import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "合同甲方"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入合同甲方"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.partyA,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "partyA", $$v);
      },
      expression: "searchForm.partyA"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "主体公司"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择主体公司"
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.subjectCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "subjectCompany", $$v);
      },
      expression: "searchForm.subjectCompany"
    }
  }, [_c("el-option", {
    attrs: {
      label: "上海良曜科技有限公司",
      value: "上海良曜科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "上海良孝科技有限公司",
      value: "上海良孝科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "北京良孝科技有限公司",
      value: "北京良孝科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "深圳良孝科技有限公司",
      value: "深圳良孝科技有限公司"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "合同状态"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择合同状态"
    },
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "status", $$v);
      },
      expression: "searchForm.status"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "未完成",
      value: "INCOMPLETE"
    }
  }), _c("el-option", {
    attrs: {
      label: "完成",
      value: "COMPLETED"
    }
  }), _c("el-option", {
    attrs: {
      label: "已作废",
      value: "VOIDED"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "合同编号"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入合同编号"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.contractNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "contractNumber", $$v);
      },
      expression: "searchForm.contractNumber"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          current: 1,
          size: 20,
          partyA: "",
          subjectCompany: "",
          status: "",
          contractNumber: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      size: "small",
      model: _vm.searchForm
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      size: "small"
    },
    on: {
      click: _vm.openDialog
    }
  }, [_vm._v("新增")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "contractNumber",
      label: "合同编号",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.fileUrls && scope.row.fileUrls.length > 0 ? _c("el-link", {
          attrs: {
            href: scope.row.fileUrls[0],
            target: "_blank",
            type: "primary"
          }
        }, [_vm._v(_vm._s(scope.row.contractNumber) + " ")]) : _c("span", [_vm._v(_vm._s(scope.row.contractNumber))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "partyA",
      label: "合同甲方",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "subjectCompany",
      label: "主体公司",
      width: "160"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "合同总金额",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s((Number(scope.row.depositAmount) + Number(scope.row.orderAmount)) % 1 === 0 ? Math.floor(Number(scope.row.depositAmount) + Number(scope.row.orderAmount)) : (Number(scope.row.depositAmount) + Number(scope.row.orderAmount)).toFixed(2)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "depositAmount",
      label: "押金金额",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "orderAmount",
      label: "订单金额",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "channelFeePaid",
      label: "已收金额",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "status",
      label: "合同状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == "INCOMPLETE" ? _c("el-tag", {
          attrs: {
            type: "info"
          }
        }, [_vm._v("未完成 ")]) : _vm._e(), scope.row.status == "COMPLETED" ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("已完成 ")]) : _vm._e(), scope.row.status == "VOIDED" ? _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("已作废 ")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "signatory",
      label: "签署人",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createdAt",
      label: "创建时间",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status != "VOIDED" ? _c("el-button", {
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.editItem(scope.row);
            }
          }
        }, [_vm._v("编辑 ")]) : _vm._e()];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.size,
      "current-page": _vm.searchForm.current,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: _vm.dialogTitle,
      visible: _vm.dialogVisible,
      width: "600px",
      "custom-class": "signing-dialog"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.resetForm
    }
  }, [_c("div", {
    staticClass: "dialog-content"
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-width": "80px",
      rules: _vm.addRules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "合同甲方",
      prop: "partyA"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入合同甲方"
    },
    model: {
      value: _vm.formData.partyA,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "partyA", $$v);
      },
      expression: "formData.partyA"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "主体公司",
      prop: "subjectCompany"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择主体公司"
    },
    model: {
      value: _vm.formData.subjectCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "subjectCompany", $$v);
      },
      expression: "formData.subjectCompany"
    }
  }, [_c("el-option", {
    attrs: {
      label: "上海良曜科技有限公司",
      value: "上海良曜科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "上海良孝科技有限公司",
      value: "上海良孝科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "北京良孝科技有限公司",
      value: "北京良孝科技有限公司"
    }
  }), _c("el-option", {
    attrs: {
      label: "深圳良孝科技有限公司",
      value: "深圳良孝科技有限公司"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "订单金额",
      prop: "orderAmount"
    }
  }, [_c("el-input", {
    attrs: {
      type: "tel"
    },
    model: {
      value: _vm.formData.orderAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "orderAmount", $$v);
      },
      expression: "formData.orderAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "押金金额",
      prop: "depositAmount"
    }
  }, [_c("el-input", {
    attrs: {
      type: "tel"
    },
    model: {
      value: _vm.formData.depositAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "depositAmount", $$v);
      },
      expression: "formData.depositAmount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "合同文件",
      prop: "fileUrls",
      rules: [{
        required: true,
        message: "请上传合同文件",
        trigger: "blur"
      }]
    }
  }, [_c("div", {
    staticClass: "contract-files"
  }, [_c("el-upload", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.uploading,
      expression: "uploading"
    }],
    staticClass: "upload-demo",
    attrs: {
      action: _vm.action,
      data: _vm.dataObj,
      multiple: false,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "on-success": _vm.uploadSuccess,
      "on-change": _vm.uploadChange,
      "auto-upload": true,
      accept: ".pdf"
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    }
  }, [_vm._v("点击上传")]), _c("div", {
    staticClass: "el-upload__tip",
    attrs: {
      slot: "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传 pdf 文件")])], 1), _vm.fileList.length > 0 ? _c("div", {
    staticClass: "pdf-list"
  }, _vm._l(_vm.fileList, function (url, index) {
    return _c("div", {
      key: index,
      staticClass: "pdf-item"
    }, [_c("i", {
      staticClass: "el-icon-document"
    }), _c("span", {
      staticClass: "filename"
    }, [_vm._v(_vm._s(url ? url.split("/").pop().split("?")[0] : ""))]), _c("div", {
      staticClass: "operations"
    }, [_c("el-button", {
      attrs: {
        type: "text"
      },
      on: {
        click: function click($event) {
          return _vm.previewFile(url);
        }
      }
    }, [_vm._v("预览 ")]), _c("el-button", {
      staticClass: "wlc-button-danger",
      attrs: {
        type: "text"
      },
      on: {
        click: function click($event) {
          return _vm.handleRemove(index);
        }
      }
    }, [_vm._v("删除 ")])], 1)]);
  }), 0) : _vm._e()], 1)])], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    staticClass: "cancel-btn",
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("返回")]), _c("el-button", {
    staticClass: "confirm-btn",
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v("确认")])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };